<template>
  <div class="ueditor">
    <div v-show="!isEdit && isHasMath">
      <div class="edit-show"  v-html="content"></div>
      <Button type="text" @click="editContent">编辑</Button>
    </div>
    <div v-show="isEdit">
      <Editor :id="id" :height="height"></Editor>
    </div>
  </div>
</template>
<script>
export default {
  name: "UEditor",
  data() {
    return {
      isEdit: true,
      id: "",
      editor: null,
      editorContent: "",
      ready: false,
      timer: 0,
      destroyed: false,
      isHasMath: false
    };
  },
  methods: {
    editContent() {
      this.$Modal.confirm({
        title: "编辑",
        content: "<p>编辑器不支持导入公式的正常展示，可能会导致公式的失效，确定继续编辑吗？</p>",
        onOk: () => {
          this.isEdit = true;
        },
        onCancel: () => {}
      });
    }
  },
  model: {
    prop: "content",
    event: "change"
  },
  props: {
    content: {
      type: String
    },
    height: {
      type: Number,
      default: 300
    },
    maxlength: {
      type: Number,
      default: 0
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Editor: {
      render(createElement) {
        return createElement("script", {
          attrs: {
            type: "text/plain",
            id: this.id,
            style: "width:100%;height:" + this.height + "px"
          }
        });
      },
      props: {
        id: { type: String, required: true },
        height: { type: Number }
      }
    }
  },
  created() {
    this.id =
      "editor" +
      new Date().getTime() +
      parseInt(Math.random() * 10000000).toString();
  },
  mounted() {
    if( this.content && this.content.match(/<math\s*\/?\s*[a-zA-z_]([^>]*?["][^"]*["])*[^>"]*>/)  ) { //富文本中含有公式
      this.isHasMath = true;
      this.isEdit = false;
      let _this = this;
      if (this.MathJax.isMathjaxConfig) { // 判断是否初始配置，若无则配置。
          this.MathJax.initMathjaxConfig()
      }
      setTimeout(function(){
        _this.MathJax.MathQueue()// 传入组件id，让组件被MathJax渲染
      },2000)
    }
    let self = this;
    this.$nextTick(async () => {
      let config = {
        autoFloatEnabled: false,
        zIndex: 99,
        readonly: this.readonly
      };
      if (this.maxlength > 0) {
        config.maximumWords = this.maxlength;
      }
      let editor = window.UE.getEditor(this.id, config);
      editor.ready(() => {
        this.ready = true;
        editor.setContent(this.content || "");
        this.timer = setInterval(() => {
          if (this.destroyed) {
            return;
          }
          self.editorContent = editor.getContent();
          self.$emit("change", self.editorContent);
        }, 500);
      });
      this.editor = editor;
    });
  },
  watch: {
    content: function(newVal) {
      if (newVal == this.editorContent) {
        return;
      }
      if (!this.ready || this.destroyed) {
        return;
      }
      if( this.content.match(/<math\s*\/?\s*[a-zA-z_]([^>]*?["][^"]*["])*[^>"]*>/)  ) { //富文本中含有公式
        this.isHasMath = true;
        this.isEdit = false;
        let _this = this;
        if (this.MathJax.isMathjaxConfig) { // 判断是否初始配置，若无则配置。
            this.MathJax.initMathjaxConfig()
        }
        setTimeout(function(){
          _this.MathJax.MathQueue()// 传入组件id，让组件被MathJax渲染
        },2000)
      }
      this.editor.setContent(newVal || "");
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.destroyed = true;
    this.editor.destroy();
  }
};
</script>
<style lang="scss" scoped>
.ueditor {
  line-height: 1;
}
.edit-show{
  min-width: 500px;
  border: 1px solid #cfcfcf;
  padding: 10px;
}
</style>
